import { render } from "./HighlightDetailView.vue?vue&type=template&id=002fbc8a&ts=true"
import script from "./HighlightDetailView.vue?vue&type=script&lang=ts"
export * from "./HighlightDetailView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__